/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Recipient_List_InvalidInputs */

const en_error_recipient_list_invalid = /** @type {(inputs: Error_Recipient_List_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The list cannot be changed as asked: correct the field marked.`)
};

/**
* | output |
* | --- |
* | "The list cannot be changed as asked: correct the field marked." |
*
* @param {Error_Recipient_List_InvalidInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const error_recipient_list_invalid = /** @type {((inputs?: Error_Recipient_List_InvalidInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Recipient_List_InvalidInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_error_recipient_list_invalid(inputs)
});